import { DataSourceExecutionEvent, Label, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutMobileCommLandmarkList } from "./autogen/AutogenLayoutMobileCommLandmarkList";

export class MobileCommLandmarkList extends AutogenLayoutMobileCommLandmarkList {
    private codeTypeMap = new Map<string, string>();

    override onLoad(): void {
    }
}
